import React from 'react';
import Reveal from '../../../reveal';
import RevealSlideDown from '../../../animations/reveal-slide-down';
import ProjectSliderWeichert from '../index';

const ProjectSliderAnimation = props => {
  return (
    <Reveal>
      <RevealSlideDown isInView={props.isInView}>
        <ProjectSliderWeichert {...props} />
      </RevealSlideDown>
    </Reveal>
  );
};

export default ProjectSliderAnimation;



// WEBPACK FOOTER //
// ./src/components/project/project-slider-weichert/project-slider-animation/index.js